import {localStorageItemName} from "src/constants/local-storage-item-name"

/**
 * Shape of the `MainConfig` stored in localStorage.
 *
 * @property {Array<{key?: string; value?: string}>} configValues - The configuration values stored in the `MainConfig`.
 */
interface StoredMainConfig {
    configValues?: {key?: string; value?: string}[]
}

/**
 * Reads one value out of the `MainConfig` business configuration kept in localStorage.
 *
 * @param {string} key - The configuration key, matched without regard to case.
 * @returns {string | undefined} The configured value, or undefined when absent or unreadable.
 */
export const readMainConfigValue = (key: string): string | undefined => {
    if (typeof window === "undefined") {
        return undefined
    }

    const stored = localStorage.getItem(localStorageItemName.mainConfig)

    if (!stored) {
        return undefined
    }

    try {
        const parsed = JSON.parse(stored) as StoredMainConfig
        const wanted = key.toLowerCase()
        const value = parsed?.configValues?.find((item) => item?.key?.toLowerCase() === wanted)?.value

        return typeof value === "string" && value.length > 0 ? value : undefined
    } catch (e) {
        console.error(`Failed to parse the MainConfig business configuration from localStorage : ${e.message}`)
        return undefined
    }
}
